import { OpaAuthorisationItem } from "../../../interfaces/opa-authorisation-item.interface";

export const authorisedOpasFilterPredicate = (data: OpaAuthorisationItem, filter: string): boolean => {
  const transformedFilter = filter.trim().toLowerCase();

  return (
    data.senderIdText.toLowerCase().includes(transformedFilter) ||
    data.statusDesc?.toLowerCase().includes(transformedFilter)
  );
};
